import RaidTerrainImage from "Components/RaidTerrainImage";
import { BUCKET_HOST } from "Constants/Common";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Nav, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getJson, Terrain } from "Utils/Common";

interface IFileList {
	[name: string]: IFileList
}
interface IProps {
	type?: string;
}
const BATCH_SIZE = 20;

const SUPPORTED_TYPES = ["raid", "grandRaid", "lbraid", "jfd"];

export default function RaidDataBridge(props:IProps) {
	const {type} = props;
	const [selectedType, setSelectedType] = useState(type ?? "raid");
	const getTypeName = (type:string) => {
		const typePath = (function () {
			switch (type) {
				case "grandRaid": return "GrandRaid";
				case "lbraid": return "Tower";
				case "jfd": return "JFD";
				default: return "Raid";
			}
		})();
		switch (typePath) {
			case "GrandRaid": return "Grand Assault";
			case "Tower": return "Final Restriction Release";
			case "JFD": return "Joint Firing Drill";
			case "Raid": return "Total Assault";
			default: return "Content";
		}
	}
	return (<>
	<Row>
		<Col
			className="bg-violet-transparent-05" >
			<Nav 
				variant="tabs" 
				defaultActiveKey={"#"+selectedType}
				activeKey={"#"+selectedType}
				onSelect={(eventKey) => setSelectedType(eventKey.substring(1))}
				>
				<Nav.Item>
					<Nav.Link eventKey="disabled" disabled>
						<strong>Type:</strong>
					</Nav.Link>
				</Nav.Item>
				{SUPPORTED_TYPES.map(file => {
					return (<Nav.Item key={file}><Nav.Link href={"#"+file}>{getTypeName(file)}</Nav.Link></Nav.Item>);
				})}
			</Nav>
		</Col>
	</Row>
	<SpecRaidDataBridge {...props} type={selectedType}/>
	</>)
}



export function SpecRaidDataBridge({type}:IProps) {
	console.log(type);
	const {server} = useParams();
	const [inputServer, setServer] = useState(server?.toLowerCase() ?? "");
	const [season, setSeason] = useState("");
	const serverKey = inputServer.toLowerCase();
	const serverName = inputServer.toUpperCase();
	const fileListPath = BUCKET_HOST+'/files/data/fileList.json';
	const [fullFileList, setFileList] = useState<IFileList>(null);
	const fileList = fullFileList?.[type ?? "raid"];
	async function loadData() {
		setFileList((await getJson(fileListPath)));
	}
	const typePath = (function () {
		switch (type) {
			case "grandRaid": return "GrandRaid";
			case "lbraid": return "Tower";
			case "jfd": return "JFD";
			default: return "Raid";
		}
	})();
	const typeName = (function () {
		switch (typePath) {
			case "GrandRaid": return "Grand Assault";
			case "Tower": return "Final Restriction Release";
			case "JFD": return "Joint Firing Drill";
			case "Raid": return "Total Assault";
			default: return "Content";
		}
	})();
	useEffect(() => {
		let ignore = false;
		if (!ignore) {
			loadData();
		}
		return () => {
			ignore = true;
		}
	}, []);

	function RaidListing({server}) {
		if (!!!server) return null;
		if (!!!fileList) return null;
		if (!!!fileList[server]) return null;
		
		return (<>
		<Row>
			<Col>
				<small>Only shows the most recent {BATCH_SIZE}. Use the dropdown for earlier data.</small>
			</Col>
		</Row>
		<Row>
			{Object.keys(fileList[server]).reverse().slice(0, BATCH_SIZE).map(season => {
				return (<Col xl={6}>
					<a href={`/${typePath}/${serverName}/${season}`}><RaidTerrainImage name={fileList[server][season]["info.json"]?.toString().split("_")[0]} terrain={season.toString()} >
						<Row>
							<Col><h3 className="text-pink">{server.toUpperCase()}: S{season} {typeName}</h3></Col>
						</Row>
					</RaidTerrainImage></a>
				</Col>)
			})}
		</Row>
	</>)
	}

	function NavTabs() {
		return (<Nav 
			variant="tabs" 
			defaultActiveKey={"#"+serverName}
			activeKey={"#"+serverName}
			onSelect={(eventKey) => setServer(eventKey.substring(1).toLowerCase())}
			>
			<Nav.Item>
				<Nav.Link eventKey="disabled" disabled>
					<strong>Server:</strong>
				</Nav.Link>
			</Nav.Item>
			{Object.keys(fileList ?? {}).map(file => {
				return (<Nav.Item key={file.toUpperCase()}><Nav.Link href={"#"+file.toUpperCase()}>{file.toUpperCase()}</Nav.Link></Nav.Item>);
			})}
		</Nav>)
	}

	return (
		<>
			<Row>
				<Col
					className="bg-violet-transparent-05" >
					<NavTabs />
				</Col>
			</Row>
			{ fileList && inputServer !== "" && (<Form.Select onChange={(event) => {
				setSeason(event?.target?.value ?? "");
			}}>
				<option>Select Season</option>
				{Object.keys(fileList[serverKey]  ?? {}).reverse().map(file => {
					let label = fileList[serverKey][file]["info.json"]?.toString() ?? "Unknown Raid";
					const parts = label.split("_");
					if (parts.length > 1) {
						label = `${parts[0]} (${parts[1]})`
					} else {
						const terrain = Terrain.default(label);
						if (!!terrain) {
							label = `${label} (${terrain})`;
						}
					}
					return (<option key={file} value={file}>{file} - {label}</option>);
				})}
			</Form.Select>)}
			{ season !== "" && inputServer !== "" && (
				<Button variant="violet" href={`/${typePath}/${serverName}/${season}`}>Go to {serverName} S{season}</Button>
			)}
			<hr></hr>
			{ !!serverKey && <RaidListing server={serverKey} />}
		</>
	);

}